import React, { useState } from 'react';
import { navigate } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  brandColours,
  brandFonts,
  fontSize,
  labelStyles,
  selectWrapStyles,
  selectStyles,
  standardColours,
} from '../styles';
import { Button } from './ui';
import { onClickDataLayer } from '../utils';

const StyledSpaVouchers = styled.div`
  padding: 35px;
  background-color: ${brandColours.primary};
  color: ${standardColours.white};

  ${minBreakpointQuery.large`
    padding: 40px;
  `}
`;

const StyledInner = styled.div`
  display: grid;
  gap: 25px;
`;

const StyledHeader = styled.header``;

const StyledHeading = styled.h3`
  ${brandFonts.secondary};
  ${fontSize(30)};

  ${minBreakpointQuery.small`
    ${fontSize(33)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(36)};
  `}
`;

const StyledText = styled.p`
  margin-top: 10px;
  line-height: 1.5;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}
`;

const StyledForm = styled.form`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: flex-end;
  gap: 15px 12px;

  ${minBreakpointQuery.mlarge`
    grid-template-columns: 4fr 2fr 8fr;
  `}
`;

const StyledField = styled.label``;

const StyledLabel = styled.span`
  ${labelStyles()};
`;

const StyledSelectWrap = styled.span`
  ${selectWrapStyles()};
`;

const StyledSelect = styled.select`
  ${selectStyles()};
`;

const StyledButton = styled(Button)`
  padding-right: 20px;
  padding-left: 20px;
  background-color: ${brandColours.tertiary};

  ${maxBreakpointQuery.mlarge`
    grid-column: span 2;
  `}
`;

const SpaVouchers = () => {
  const [voucherAmount, setVoucherAmount] = useState(25);

  const handleSubmit = async e => {
    e.preventDefault();
    const voucherForm = document.getElementById('voucher-form');
    const formData = new FormData(voucherForm);

    const voucherId = formData.get('voucher-amount');
    const quantity = formData.get('voucher-qty');

    const dataLayer = {
      checkout: {
        step: 1,
        option: 'Configure',
      },
    };

    const product = [
      {
        name: `£${voucherAmount} Voucher`,
        id: `£${voucherAmount} Voucher`, // not sure if this is correct for a voucher
        price: voucherAmount, // not sure if this is correct for a voucher (or we need to times by the quantity)
        brand: 'SpaSeekers',
        category: 'Voucher', // not sure if this is correct for a voucher
        quantity: parseInt(quantity),
      },
    ];

    onClickDataLayer(dataLayer, product);

    navigate('/checkout/voucher-configuration', {
      state: {
        voucherId: voucherId,
        quantity: quantity,
        value: parseInt(voucherAmount),
      },
    });
  };

  return (
    <StyledSpaVouchers>
      <StyledInner>
        <StyledHeader>
          <StyledHeading>Gift Vouchers</StyledHeading>
          <StyledText>
            Buy a monetary spa voucher to suit your budget
          </StyledText>
        </StyledHeader>
        <StyledForm
          id="voucher-form"
          onSubmit={e => {
            handleSubmit(e);
          }}
        >
          <StyledField>
            <StyledLabel>Amount</StyledLabel>
            <StyledSelectWrap>
              <StyledSelect
                name="voucher-amount"
                onChange={event => {
                  setVoucherAmount(
                    event.target[event.target.selectedIndex].getAttribute(
                      'data-amount',
                    ),
                  );
                }}
                required
              >
                <option value="44" data-amount="25">
                  £25.00
                </option>
                <option value="70" data-amount="30">
                  £30.00
                </option>
                <option value="102" data-amount="40">
                  £40.00
                </option>
                <option value="422" data-amount="45">
                  £45.00
                </option>
                <option value="45" data-amount="50">
                  £50.00
                </option>
                <option value="73" data-amount="60">
                  £60.00
                </option>
                <option value="178" data-amount="70">
                  £70.00
                </option>
                <option value="46" data-amount="75">
                  £75.00
                </option>
                <option value="202" data-amount="80">
                  £80.00
                </option>
                <option value="167" data-amount="90">
                  £90.00
                </option>
                <option value="299" data-amount="95">
                  £95.00
                </option>
                <option value="47" data-amount="100">
                  £100.00
                </option>
                <option value="269" data-amount="110">
                  £110.00
                </option>
                <option value="118" data-amount="120">
                  £120.00
                </option>
                <option value="68" data-amount="125">
                  £125.00
                </option>
                <option value="156" data-amount="130">
                  £130.00
                </option>
                <option value="418" data-amount="135">
                  £135.00
                </option>
                <option value="136" data-amount="140">
                  £140.00
                </option>
                <option value="394" data-amount="145">
                  £145.00
                </option>
                <option value="48" data-amount="150">
                  £150.00
                </option>
                <option value="294" data-amount="160">
                  £160.00
                </option>
                <option value="323" data-amount="165">
                  £165.00
                </option>
                <option value="293" data-amount="170">
                  £170.00
                </option>
                <option value="117" data-amount="200">
                  £200.00
                </option>
                <option value="50" data-amount="250">
                  £250.00
                </option>
                <option value="51" data-amount="300">
                  £300.00
                </option>
                <option value="52" data-amount="350">
                  £350.00
                </option>
                <option value="53" data-amount="400">
                  £400.00
                </option>
                <option value="465" data-amount="425">
                  £425.00
                </option>
                <option value="54" data-amount="450">
                  £450.00
                </option>
                <option value="55" data-amount="500">
                  £500.00
                </option>
                <option value="56" data-amount="550">
                  £550.00
                </option>
                <option value="57" data-amount="600">
                  £600.00
                </option>
                <option value="58" data-amount="650">
                  £650.00
                </option>
                <option value="59" data-amount="700">
                  £700.00
                </option>
                <option value="60" data-amount="750">
                  £750.00
                </option>
                <option value="61" data-amount="800">
                  £800.00
                </option>
                <option value="62" data-amount="850">
                  £850.00
                </option>
                <option value="63" data-amount="900">
                  £900.00
                </option>
                <option value="64" data-amount="950">
                  £950.00
                </option>
                <option value="65" data-amount="1000">
                  £1000.00
                </option>
              </StyledSelect>
            </StyledSelectWrap>
          </StyledField>
          <StyledField>
            <StyledLabel>Qty</StyledLabel>
            <StyledSelectWrap>
              <StyledSelect name="voucher-qty">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
              </StyledSelect>
            </StyledSelectWrap>
          </StyledField>
          <StyledButton>Add to Basket</StyledButton>
        </StyledForm>
      </StyledInner>
    </StyledSpaVouchers>
  );
};

export default SpaVouchers;
